module.exports = __webpack_public_path__ + "static/media/passing_by_amber.6abe9617.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/passing_by_amber.svg
// module id = 1094
// module chunks = 2